import { graphql } from "@opensea/graphql"

export const ListingFlowDone_itemFragment = graphql(`
  fragment ListingFlowDone_item on Item {
    chain {
      identifier
    }
    contractAddress
    tokenId
    name
    imageUrl
    collection {
      id
      name
      slug
    }
  }
`)
